import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDrink: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"drink, cup, straw, mug"} maskId="square-filled-radius-0-stroke-1-IconDrink"><path fillRule="evenodd" clipRule="evenodd" d="M12.001 2.90109L16.5975 1.87963L16.3806 0.903442L11.001 2.09892V6H4.96875L6.03125 23H17.9707L19.0332 6H12.001V2.90109ZM17.9688 7L17.7188 11H6.2832L6.0332 7H17.9688Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDrink;
